import { TeachingLoadReportType } from '@bp/planung-graphql-types';
import { Card, Grid, GridColumn, GridRow } from '@bp/ui-components';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { TeachingLoadReportsTable } from '../../../../components/Deputate/Tables/TeachingLoadReportsTable';
import {
  TeachingLoadReportTypesTable,
  TeachingLoadReportTypesTableType,
} from '../../../../components/Deputate/Tables/TeachingLoadReportTypesTable';
import { TeachingLoadReportConfigurationModal } from '../../../../components/TeachingLoadReportConfiguration/modals/TeachingLoadReportConfigurationModal';
import { supportsConfiguration } from '../../../../components/TeachingLoadReportConfiguration/supportsConfiguration';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const DeputateEvaluatePlannedReportsSubpage = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  const { blockUuid } = useParams();
  const timetableBlockUuid = blockUuid === t('routes.deputate.evaluate.all.slug') ? 'all' : (blockUuid ?? 'all');

  // Stabile Referenz: die Tabelle setzt bei neuen data ihren Zustand zurück.
  const tableData: TeachingLoadReportTypesTableType[] = useMemo(
    () => [
      { type: TeachingLoadReportType.PlanSingleTeacher, name: t('pdf.plannedDetails') },
      { type: TeachingLoadReportType.PlanOverview, name: t('pdf.plannedOverview') },
      { type: TeachingLoadReportType.PlanSubjectGroup, name: t('pdf.plannedSubjectGroups') },
      { type: TeachingLoadReportType.PlanClass, name: `${t('pdf.plannedClasses')} (${t('common.commingSoon')})` },
      { type: TeachingLoadReportType.Curriculum, name: `${t('pdf.plannedTeachingLoad')} (${t('common.commingSoon')})` },
      { type: TeachingLoadReportType.PlanKeyFigures, name: `${t('pdf.plannedKeyFigures')} BETA` },
      { type: TeachingLoadReportType.PlanExcel, name: t('pdf.excelExport') },
      { type: TeachingLoadReportType.PlanLeliste, name: t('pdf.plannedlelisteExport') },
    ],
    [t],
  );

  const [headline, setHeadline] = useState<string>(tableData[0].name);
  const [subType, setSubType] = useState<TeachingLoadReportType>(tableData[0].type);
  const [showConfigModal, setShowConfigModal] = useState<boolean>(false);

  function handleSelect(subType: TeachingLoadReportType, headline: string) {
    setHeadline(headline);
    setSubType(subType);
  }

  return (
    <>
      <Grid>
        <GridRow mobileGap={'32px'}>
          <GridColumn width={6}>
            <Card header={{ headline: t('timetable.title', { count: 2 }) }} contentPadding='none'>
              <TeachingLoadReportTypesTable data={tableData} onSelect={handleSelect} />
            </Card>
          </GridColumn>
          <GridColumn width={6}>
            <Card
              header={{
                headline,
                actions: [
                  {
                    text: t('deputate.configuration.configure'),
                    callback: () => setShowConfigModal(true),
                    disabled: !permissions?.canWriteDeputate() || !supportsConfiguration(subType),
                  },
                ],
              }}
              contentPadding='none'
            >
              <TeachingLoadReportsTable
                showEmptyState={
                  subType === TeachingLoadReportType.Curriculum || subType === TeachingLoadReportType.PlanClass
                }
                subType={subType}
                timetableBlockUuid={timetableBlockUuid}
              />
            </Card>
          </GridColumn>
        </GridRow>
      </Grid>

      <TeachingLoadReportConfigurationModal
        isOpen={showConfigModal}
        subType={subType}
        onClose={() => setShowConfigModal(false)}
      />
    </>
  );
};
